import clx from 'classnames';
import styled from 'styled-components';
import { FlexRow, type FlexRowProps } from '../row/FlexRow.tsx';

const EvidenceCardWrapper = styled.div`
  flex: 1;
  position: relative;
  border: 2px solid ${props => props.theme.colorSplit};
  border-radius: 8px;
  padding: 12px;
  transition: all 0.3s ease-in-out;
  background: ${props => props.theme.colorBgContainer};
  &.remove-top-padding {
    padding-top: 0;
  }
`;

export interface ISwitchEvidenceCardProps extends FlexRowProps {
  /**
   * Permette di rimuovere il padding superiore della card,
   * ad esempio se contiene un formitem senza label,
   * dove lo spazio superiore sarebbe sproporzionato.
   */
  removeTopPadding?: boolean;
}

/**
 * Card in evidenza che racchiude un controllo (tipicamente uno switch) con
 * titolo e descrizione. È un wrapper puramente grafico: estende `FlexRow`,
 * quindi accetta `left`/`right`/`align`… per posizionare gli elementi
 * (es. un tag di stato a destra).
 *
 * Per il `FormItem` che la avvolge usare `SWITCH_EVIDENCE_CARD_LAYOUT`
 * (o `CHECKBOX_EVIDENCE_CARD_LAYOUT` per una checkbox annidata) da
 * `@framework/form/item/formItemLayouts.ts`.
 */
export function SwitchEvidenceCard({
  children,
  removeTopPadding,
  ...flexRowProps
}: ISwitchEvidenceCardProps) {
  return (
    <EvidenceCardWrapper
      className={clx({ 'remove-top-padding': removeTopPadding })}
    >
      <FlexRow {...flexRowProps}>{children}</FlexRow>
    </EvidenceCardWrapper>
  );
}
